<template>  
  <transition name="fade">
    <div class="position-relative" style="z-index: 1043">
      <div class="row no-gutters justify-content-center">
        <div class="fixed-bottom d-block nav-bottom" style="bottom:0;top: 0">
          <div class="custom-container-fluid px-0" style="box-shadow: 1px 0px 6px 2px #dfdfdf4f">
            <div class="row justify-content-center no-gutters">
              <div class="col-xl-4 col-lg-4 col-md-6 col-sm-8 col-12 position-relative">
                <div class="bg-white box-shadow-main popup-scroll scroll-hide-mobile popup-scroll-body" style="height: 100vh">
                  <div class="bg-white pb-4 mb-3">
                    <div class="w-100">
                      <img src="../../../../assets/img/icon/cancel.png" class="d-inline-block p-2 rounded-3 bg-back mt-3 mx-4 cursor-pointer position-absolute" width="33" @click="detailRoom()" style="z-index: 1038">
                      <div class="">
                        <template v-if="data.image == 0">
                          <div class="w-100" style="height: 230px !important;">
                            <img src="../../../../assets/img/icon/hotel-placeholder.svg"
                              class="img-fit" height="150">
                          </div>
                        </template>
                        <div class="position-relative" v-else>
                          <template v-if="!isImageGridView">
                            <flickity ref="flickity" class="room-detail text-center" :options="flickityOptions">
                              <div v-for="image in roomImages" class="carousel-cell w-100">
                                <div class="w-100 position-relative bg-dark-transparent room-image-frame">
                                  <img :src="image.image_url" class="position-relative z-index-1045 room-image-contain">
                                  <div class="position-absolute w-100 z-index-1042 bg-blur-overlay" :style="{ backgroundImage: `url('${image.image_url}')` }"></div>
                                </div>
                              </div>
                            </flickity>
                            <div class="room-image-indicator" v-if="hasMultipleImages">
                              <div class="room-image-dots-window" :style="{ maxWidth: dotsWindowMaxWidth }">
                                <div class="room-image-dots" :style="dotsTrackStyle">
                                  <span class="room-image-dot" :class="{ 'is-active': index === activeImageIndex }" v-for="(image, index) in roomImages" :key="index"></span>
                                </div>
                              </div>
                            </div>
                            <div class="slider-action-btn prev" @click="slideTheSlider('prev')">
                              <svg class="transform-180" width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <circle cx="11" cy="11" r="10.5" transform="rotate(-180 11 11)" fill="white" stroke="#D9D9D9"/>
                                <path d="M13.4816 10.9821C13.4816 10.8609 13.4332 10.7398 13.3411 10.6574L9.49798 6.90636C9.41559 6.82398 9.30897 6.77551 9.18782 6.77551C8.93581 6.77551 8.74196 6.96454 8.74196 7.21652C8.74196 7.33769 8.79042 7.44914 8.86796 7.53156L12.6626 11.2438V10.7252L8.86796 14.4375C8.79042 14.515 8.74196 14.6265 8.74196 14.7525C8.74196 15.0045 8.93581 15.1935 9.18782 15.1935C9.30897 15.1935 9.41559 15.145 9.50283 15.0626L13.3411 11.3116C13.4332 11.2196 13.4816 11.1081 13.4816 10.9821Z" fill="black" fill-opacity="0.85"/>
                              </svg>
                            </div>
                            <div class="slider-action-btn next" @click="slideTheSlider('next')">
                              <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <circle cx="11" cy="11" r="10.5" transform="rotate(-180 11 11)" fill="white" stroke="#D9D9D9"/>
                                <path d="M13.4816 10.9821C13.4816 10.8609 13.4332 10.7398 13.3411 10.6574L9.49798 6.90636C9.41559 6.82398 9.30897 6.77551 9.18782 6.77551C8.93581 6.77551 8.74196 6.96454 8.74196 7.21652C8.74196 7.33769 8.79042 7.44914 8.86796 7.53156L12.6626 11.2438V10.7252L8.86796 14.4375C8.79042 14.515 8.74196 14.6265 8.74196 14.7525C8.74196 15.0045 8.93581 15.1935 9.18782 15.1935C9.30897 15.1935 9.41559 15.145 9.50283 15.0626L13.3411 11.3116C13.4332 11.2196 13.4816 11.1081 13.4816 10.9821Z" fill="black" fill-opacity="0.85"/>
                              </svg>
                            </div>
                          </template>

                          <div v-else class="room-image-grid">
                            <div v-for="(image, index) in roomImages" :key="index" @click="openImageAtIndex(index)">
                              <img :src="image.image_url" class="room-image-grid-img">
                            </div>
                          </div>

                          <button type="button" class="room-image-view-toggle" v-if="hasMultipleImages"
                            @click="toggleImageViewMode">
                            <LayoutGrid v-if="!isImageGridView" :size="14" />
                            <ImageIcon v-else :size="14" />
                            <span>{{imageViewToggleLabel}}</span>
                          </button>
                        </div>
                        <div class="container px-4 pt-4">
                          <!-- ROOM TYPE NAME -->
                          <p class="mb-3 body-1-4 text-22 w-90">{{data.name}}</p>

                          <!-- DESCRIPTION -->
                          <div class="mb-4" v-if="!(data.description == null || data.description == '')">
                            <p class="mb-1 body-1-4">{{$t('general.description')}}</p>
                            <p class="mb-4 body-2-2 html-desc multiline-text" v-html="data.description"></p>
                          </div>

                          <!-- ROOM INFORMATION -->
                          <div class="border-semi-grey p-3 rounded-4 mb-4">
                            <div class="row slim-grid-row">
                              <div class="col-6 mb-3" v-if="data.room_size !== '0'">
                                <p class="mb-0 body-3 lh-1">{{$t('hotel.unit-type.'+data.type+'.size')}}</p>
                                <div class="w-100">
                                  <i class="simple-icon-size-fullscreen text-green text-14 d-inline-block align-middle mr-1 font-weight-bold"></i>
                                  <p class="mb-0 body-2-1 d-inline-block align-middle">{{data.room_size}}m²</p>
                                </div>
                              </div>
                              <div class="col-6 mb-3" v-if="!(data.total_rooms == null || data.total_rooms == '' || data.total_rooms == 0)">
                                <p class="mb-0 body-3 lh-1">{{$t('hotel.room-type.total-bedroom')}}</p>
                                <div class="w-100">
                                  <i class="simple-icon-home text-green text-14 d-inline-block align-middle mr-1 font-weight-bold"></i>
                                  <p class="mb-0 body-2-1 d-inline-block align-middle">{{data.total_rooms}} {{$pluralWord(data.total_rooms,'Bedroom')}}</p>
                                </div>
                              </div>
                              <div class="col-12" v-if="data.bed.length > 0">
                                <p class="mb-0 body-3 lh-1">{{$t('hotel.room-type.bed-type')}}</p>
                                <div class="w-100">
                                  <i class="simple-icon-grid text-green text-14 d-inline-block align-middle mr-1 font-weight-bold"></i>
                                  <p class="mb-0 body-2-1 d-inline-block align-middle">
                                    <template v-for="(bed, index) in data.bed">
                                      {{bed.qty}} {{bed.name}}
                                      <span v-if="index + 1 < data.bed.length">, </span>
                                    </template>
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>


                          <div class="row slim-grid-row mb-4">
                            <div class="col-12 mb-2">
                              <p class="mb-0 body-1-4">Recommended occupancy</p>
                            </div>
                            <div class="col-4" v-if="data.max_adults > 0">
                              <p class="mb-0 body-3 lh-1">Adult</p>
                              <p class="mb-0 body-2-1 d-inline-block align-middle">{{data.max_adults}} Guest</p>
                            </div>
                            <div class="col-4" v-if="data.max_children > 0">
                              <p class="mb-0 body-3 lh-1">Children</p>
                              <p class="mb-0 body-2-1 d-inline-block align-middle">{{data.max_children}} Guest</p>
                            </div>
                            <div class="col-4" v-if="data.max_infant > 0">
                              <p class="mb-0 body-3 lh-1">Infant</p>
                              <p class="mb-0 body-2-1 d-inline-block align-middle">{{data.max_infant}} Guest</p>
                            </div>
                          </div>
                          
                          <!-- FACILITIES -->
                          <div class="mb-4" v-if="data.facility != 0 && data.facility != undefined">
                            <p class="mb-2 body-3-3 text-16 font-bold">{{$t('hotel.room-type.room-facilities')}}</p>
                            <Facilities :facilities="data.facility"></Facilities>
                          </div>

                          <template v-if="data.policy != 0 && data.policy != undefined">
                            <p class="pt-4 mb-2 body-3-3 text-16 font-bold">{{$t('hotel.room-policy')}}</p>
                            <div>
                              <ul class="pl-3">
                                <li v-for="(policy, index) in data.policy">
                                  <p class="mb-1 font-bold body-2-2 text-14">{{policy.title}}</p>
                                  <p class="mb-2 body-2-2 text-14 font-regular html-desc multiline-text" v-html="policy.description"></p>
                                </li>
                              </ul>
                            </div>
                          </template>
                          <div class="height-100px"></div>
                          <div class="position-relative" style="z-index: 1037">
                            <div class="row no-gutters justify-content-center">
                              <div class="fixed-bottom d-block nav-bottom" style="bottom:0px">
                                <div class="custom-container-fluid px-0">
                                  <div class="row justify-content-center no-gutters">
                                    <div class="col-xl-4 col-lg-4 col-md-6 col-sm-8 col-12 position-relative">
                                      <div class="container px-4 py-2 bg-white box-shadow-footer">
                                        <template>
                                          <div class="w-100 text-right mb-1 d-inline-block" >
                                            <p class="mb-0 body-2-2 text-14 font-semibold d-inline-block float-left cursor-pointer">{{$t('hotel.starting-from')}} :</p>
                                            <p class="mb-0 body-2-2 text-16 font-bold text-orange d-block cursor-pointer">{{formatCurrency(data.best_price.final_price)}}</p>
                                            <p class="mb-0 body-2 text-12 font-regular d-block">/ {{$t('hotel.unit-type.'+data.type+'.per-unit-night')}}</p> 
                                            </div>
                                        </template>
                                        <button type="button" @click="detailRoom()" class="button-secondary w-100">{{$t('hotel.see-rates')}}</button>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
  import Flickity from 'vue-flickity';
  import Facilities from '@/components/hotel/facilities';
  import {formatCurrency,formatDate} from '@/utils/index.js'
  import {mapGetters} from 'vuex'
  import { LayoutGrid, Image as ImageIcon } from 'lucide-vue';
  import moment from 'moment'

  const MAX_VISIBLE_DOTS = 7;
  const DOT_PITCH_PX = 16;

  export default{
    props: ['data'],
    components:{
      Flickity,
      Facilities,
      LayoutGrid,
      ImageIcon
    },
    data(){
      return{
        detail_room: false,
        imageViewMode: 'slider',
        flickityOptions: {
          initialIndex: 0,
          autoPlay: 5000,
          prevNextButtons: false,
          pageDots: false,
          adaptiveHeight: true,
          draggable: false,
          wrapAround: true,
        },
        more_policy: true,
        activeImageIndex: 0,
      }
    },
    computed:{
      roomImages(){
        return (this.data && Array.isArray(this.data.image)) ? this.data.image : []
      },
      isImageGridView(){
        return this.imageViewMode === 'grid'
      },
      hasMultipleImages(){
        return this.roomImages.length > 1
      },
      imageViewToggleLabel(){
        return this.isImageGridView ? this.$t('hotel.room-type.slider-view') : this.$t('hotel.room-type.show-all-photos')
      },
      imageCount(){
        return this.roomImages.length
      },
      dotsWindowMaxWidth(){
        return (Math.min(this.imageCount, MAX_VISIBLE_DOTS) * DOT_PITCH_PX) + 'px'
      },
      // Keep the active dot centered inside the fixed-width window so the strip never outgrows the image
      dotsTrackStyle(){
        if(this.imageCount <= MAX_VISIBLE_DOTS) return {}
        const lastWindowStart = this.imageCount - MAX_VISIBLE_DOTS
        const centerOffset = Math.floor(MAX_VISIBLE_DOTS / 2)
        const windowStart = Math.min(Math.max(this.activeImageIndex - centerOffset, 0), lastWindowStart)
        return { transform: 'translateX(-'+(windowStart * DOT_PITCH_PX)+'px)' }
      }
    },
    created(){
      // plain instance property: restoring an inline style is not view state
      this.previous_body_overflow = '';
    },
    mounted(){
     this.$sendEventMetaConversionsAPI('ViewContent', {
        id: this.data.id,
        name: this.data.name,
        room_rate: this.data.room_rate
      }, 'Room Type');
     this.bindFlickityChange();
     this.lockPageScroll();
    },
    beforeDestroy(){
      this.unlockPageScroll();
    },
    methods:{
      // Keeps the page on the room type the guest opened, so closing lands them back on it
      lockPageScroll(){
        this.previous_body_overflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
      },
      unlockPageScroll(){
        document.body.style.overflow = this.previous_body_overflow || '';
      },
      ...mapGetters(['getBeSortBy','getMerchant']),
      detailRoom(){
        this.$emit('closeDetailRoom');
      },
      formatTime(time){
        return moment(time,"HH:mm:ss").format("HH:mm")
      },
      bedCounter(bed){
        let display = ''
        for(let i = 0; i < bed.length; i++){
          if((i+1) == bed.length){
            display += (bed[i].qty+' '+bed[i].name)
          }else{
            display += ((bed[i].qty+' '+bed[i].name)+', ')
          }
        }
        return display
      },
      formatCurrency(value){
        return formatCurrency(value);
      },
      isToggle(data){
        this.more_policy = data
      },
      setActiveImageIndex(index){
        this.activeImageIndex = index
      },
      slideTheSlider(action='next'){
        if(this.$refs.flickity){
          if(action === 'next') this.$refs.flickity.next();
          else this.$refs.flickity.previous();
        }
      },
      bindFlickityChange(){
        if(this.$refs.flickity){
          this.$refs.flickity.on('change', this.setActiveImageIndex)
        }
      },
      setImageViewMode(mode){
        // Flickity reads initialIndex only at construction, so seed it before the slider remounts
        if(mode === 'slider') this.flickityOptions.initialIndex = this.activeImageIndex
        this.imageViewMode = mode
        if(mode === 'slider') this.$nextTick(this.bindFlickityChange)
      },
      toggleImageViewMode(){
        this.setImageViewMode(this.isImageGridView ? 'slider' : 'grid')
      },
      openImageAtIndex(index){
        this.activeImageIndex = index
        this.setImageViewMode('slider')
      }
    },
  }
</script>
<style scoped>
  .room-image-frame {
    height: 300px;
  }
  .room-image-contain {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
  .bg-dark-transparent {
    background-color: rgb(35 35 35 / 88%);
  }
  .room-image-indicator {
    position: absolute;
    bottom: 10px;
    left: 0;
    right: 0;
    display: flex;
    justify-content: center;
    z-index: 1046;
    pointer-events: none;
  }
  .room-image-dots-window {
    overflow: hidden;
  }
  .room-image-dots {
    display: flex;
    transition: transform 0.25s ease;
  }
  .room-image-dot {
    flex: 0 0 auto;
    width: 8px;
    height: 8px;
    margin: 0 4px;
    border-radius: 50%;
    background: #fff;
    opacity: 0.5;
    transition: opacity 0.2s ease, background-color 0.2s ease;
  }
  .room-image-dot.is-active {
    opacity: 1;
    background: var(--merchant-primary-color);
  }
  .bg-blur-overlay {
    height: 100%;
    filter: blur(10px);
    top: 0px;
    left: 0px;
    opacity: 0.5;
    background-size: cover;
    background-position: center;
  }
  .room-image-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    /* Rows must not stretch, otherwise a short gallery leaves tall gaps between images */
    align-content: start;
    gap: 8px;
    /* Bounded height keeps the floating toggle anchored while the grid scrolls */
    max-height: 70vh;
    overflow-y: auto;
    padding: 8px 8px 60px;
    background: #fff;
  }
  .room-image-grid-img {
    display: block;
    width: 100%;
    height: 120px;
    object-fit: cover;
    border-radius: 8px;
    cursor: pointer;
  }
  .room-image-view-toggle {
    position: absolute;
    bottom: 24px;
    right: 12px;
    z-index: 1047;
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 7px 12px;
    background: #fff;
    color: #1a1a2e;
    font-size: 12px;
    font-weight: 600;
    border: 1px solid #d5d9e0;
    border-radius: var(--be-v3-button-radius, 8px);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    cursor: pointer;
  }
</style>


// WEBPACK FOOTER //
// src/components/hotel/be/mobile/roomTypeDetail.vue